// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"68f7edaf","638":"ec9f19d2","684":"d55e5937","869":"af7d505b"}[chunkId] + ".chunk.js";
};